import { analyticsClient } from '../../client/analytics';

export default function getDownloadFormData(playbookTitle) {
  return {
    type: 'download',
    pages: [
      {
        elements: [
          {
            type: 'title',
            label: 'Download this conversion secret as a PDF',
          },
          {
            type: 'email',
            label: 'Your work email',
            validation: 'email',
            required: true,
          },
          {
            type: 'checkbox',
            name: 'newsletter-signup',
            label: 'Send me a new conversion secret each week',
          },
          {
            type: 'button',
            label: 'Download this playbook',
            modifier: 'Button--deepPurpleFill',
            action: 'next',
            subscribe: true,
            onSubmit: (email, newsletterSignup) =>
              analyticsClient.track('[Website] Playbook download', {
                email,
                playbook: playbookTitle,
                conversion_secrets_subscription: newsletterSignup,
              }),
          },
        ],
      },
      {
        elements: [
          {
            type: 'button',
            label: 'Download now',
            modifier: 'Button--deepPurple',
            action: 'pdf-download',
          },
        ],
      },
    ],
  };
}
